var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-image" }, [
    _c("div", { staticClass: "image-container" }, [
      _c("img", {
        class: { default: !_vm.user.profile_image },
        attrs: { src: _vm.profileImageSource },
        on: { error: _vm.refreshUserImage }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f9ad16", { render: render, staticRenderFns: staticRenderFns })
  }
}